import { v4 as uuidv4 } from 'uuid';

export const initSession = () => {
  // Generate new session ID
  const sessionId = uuidv4();

  let userId = window.localStorage.getItem('userId');
  if (!userId) {
    userId = uuidv4();
    window.localStorage.setItem('userId', userId);
  }

  if (!window.eventData) {
    window.eventData = {};
  }
  window.eventData.sessionId = sessionId;
  window.eventData.userId = userId;

  return sessionId;
};

export const getCurrentSessionId = () => {
  return window.eventData?.sessionId;
};

// Handle page refresh
window.addEventListener('beforeunload', () => {
  // Generate new session ID for next page load
  const newSessionId = uuidv4();
  if (window.eventData) {
    window.eventData.nextSessionId = newSessionId;
  }
});

// Initialize new session on page load
window.addEventListener('load', () => {
  if (window.eventData?.nextSessionId) {
    window.eventData.sessionId = window.eventData.nextSessionId;
    delete window.eventData.nextSessionId;
  } else {
    initSession();
  }
});
